import { useDispatch, useSelector } from "react-redux";
import { selectMap } from "../../features/counter/counterSlice";
import generateTocForCurrentPath, {
  getUmbrellaMenuItems,
} from "../../components/TableOfContents/tocGeneration";
import {
  setTableOfContentsAndActiveItem,
  setActiveItem,
  setUmbrellaNode,
  setTabClickLock,
} from "../../features/tableOfContents/TableOfContentsSlice";
import { useEffect } from "react";
import { isSameItem } from "./tableOfContents";

export function useTableOfContentsItems(menuItem) {
  const dartMap = useSelector(selectMap);
  const dispatch = useDispatch();
  const { tableOfContents } = useSelector((state) => state.tableOfContents);

  useEffect(() => {
    if (!dartMap) {
      // dartMap has just been cleared (resetState on navigation). Lock the
      // scroll handler so it cannot overwrite activeItem with children[0]
      // while the page is empty / scrolled to the top during reload.
      setTabClickLock();
      return;
    }
    const { chapterNode: tocItems, activeNode } = generateTocForCurrentPath(dartMap, menuItem);
    const umbrellaNode = getUmbrellaMenuItems(dartMap, menuItem);
    if (!isSameItem(tocItems, tableOfContents)) {
      // Chapter changed: atomically set both tableOfContents and activeItem so
      // there is never an intermediate render showing children[0].
      dispatch(setTableOfContentsAndActiveItem({ tocItems, activeNode }));
      dispatch(setUmbrellaNode(umbrellaNode));
    } else if (activeNode) {
      // Same chapter structure but URL points to a specific topic (topicfile).
      // Update activeItem so the TOC highlights the correct item when navigating
      // between sections of the same guideline (e.g. browser back/forward).
      dispatch(setActiveItem(activeNode));
    }
  }, [dartMap, menuItem, dispatch]);
}
